var isCustomInterval = function (interval) {
  return interval.includes('every');
};

var extractGroupSettings = function (groupBy) {
  if (typeof groupBy === 'string') return [groupBy];
  return groupBy;
};

export { extractGroupSettings as extractGroupBySettings, isCustomInterval };
//# sourceMappingURL=index.esm.js.map
